<template>
  <span :class="className" :style="`font-size:${fontSize}px`">
    <svg class="iconSymbol" aria-hidden="true">
      <use :xlink:href="'#' + icon" />
    </svg>
  </span>
</template>
<script>
export default {
	props: {
		icon: {
			type: String,
			default: ''
		},

		fontSize: {
			type: String,
			default: '24'
		},
		className: {
			type: String,
			default: '',
		}
	}
}
</script>

<style>
</style>